import { Form, Select } from "antd";
import { FC } from "react";
import { useGetClient } from "~/services/client";
import { formatFullAddress } from "~/utils";

type Props = {
  clientId: string;
};

export const SelectClientAddress: FC<Props> = ({ clientId }) => {
  const { data: client, isLoading } = useGetClient(clientId);
  return (
    <Form.Item
      name="shippingAddressId"
      label="Client Address"
      rules={[
        {
          required: true,
          message: "Please select a client address!",
        },
      ]}
    >
      <Select
        loading={isLoading}
        options={client?.shippingAddresses?.map((address) => ({
          label: formatFullAddress(address),
          value: address.id,
        }))}
        placeholder="Select client address..."
      />
    </Form.Item>
  );
};
